import { get, compose, isEqual, isNil, overEvery } from 'lodash/fp';
import { createSelector } from 'reselect';
import { array } from 'fp-ts';
import { flow } from 'fp-ts/function';
import { createLocalizedHours } from '@mews/business-components';
import { getNumberProp, getStringProp, ifElse } from '@mews/fp';
import { getCurrentDateTimeLocalizationInfo } from '@mews-commander/core/legacy-globalization';
import { BASE_PRICE_ADJUSTMENTS_SIDEBAR } from '../constants';
import { moduleSelector } from '../module';
import { getBasePrice, getAttributePrices } from './data';
import { getAttributePriceAdjustmentFormName, getRateAdjustmentFormName } from './formName';

const parentSidebarSelector = createSelector(moduleSelector, get('sidebar'));

const openedSidebarSelector = compose(get('opened'), parentSidebarSelector);

export const getSelectedAttributeId = compose(get('selectedAttributeId'), parentSidebarSelector);

export const isBasePriceFormSidebarOpened = createSelector(
    openedSidebarSelector,
    isEqual(BASE_PRICE_ADJUSTMENTS_SIDEBAR)
);
export const isRateAdjustmentFormSidebarOpened = createSelector(
    getRateAdjustmentFormName,
    openedSidebarSelector,
    isEqual
);
export const isAttributePriceAdjustmentFormSidebarOpened = createSelector(
    getAttributePriceAdjustmentFormName,
    openedSidebarSelector,
    isEqual
);

export const getHighlightedCellRange = createSelector(parentSidebarSelector, get('highlightedCellRange'));

const isCellAttributeIdSameAsSelected = createSelector(getStringProp('id'), getSelectedAttributeId, isEqual);

const isCellIndexWithinHighlightedCellRange = createSelector(
    getNumberProp('cellIndex'),
    getHighlightedCellRange,
    (currentCellIndex, { startIndex, endIndex }) => currentCellIndex >= startIndex && currentCellIndex <= endIndex
);

export const isCellHighlighted = overEvery([isCellAttributeIdSameAsSelected, isCellIndexWithinHighlightedCellRange]);

const getSelectedAttributePricing = createSelector(getSelectedAttributeId, getAttributePrices, get);

const getSelectedPricing = ifElse(compose(isNil, getSelectedAttributeId), getBasePrice, getSelectedAttributePricing);

export const getSelectedPricingPrices = createSelector(getSelectedPricing, get('prices'));

export const getLocalizedHourValues = createSelector(
    getCurrentDateTimeLocalizationInfo,
    flow(
        createLocalizedHours,
        array.map(({ value }) => value)
    )
);
